// js/sections/BlogSection.js

class BlogSection extends HTMLElement {
  constructor() {
    super();

    // Mobile tag selector now uses <dialog class="modal modal--popover">
    // wired by assets/value-picker-dialog.js — no per-instance JS needed.
    if (Shopify.designMode) {
      let elementToAdd = this.querySelector(".page__header");
      if (elementToAdd) {
        document.querySelector(".blog-container").previousElementSibling.remove();
        document.querySelector(".blog-container").insertAdjacentElement("beforebegin", elementToAdd);
      }
    }
  }
  connectedCallback() {
    // Re-initialize if needed when element is connected
  }
}
if (!window.customElements.get("cos-blog")) window.customElements.define("cos-blog", BlogSection);
